
// @ts-nocheck



import { i18nText } from '@/locales';

import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {minValue, required} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import { ServiceNomenclatureCreateRequestType } from "./serviceNomenclatureCreate.types";
import {
    IServicesCategoryNomenclature
} from "@/entity/servicesCategoryNomenclature/services.category.nomenclature.types";

@Component
export default class ServiceNomenclatureCreateForm extends Form{
    @Validate(required, i18nText("Введите название услуги"))
    name = '';
    online_appointment_name = null;
    description = null;

    @Validate(required, i18nText("Является ли запись активной"))
    active: boolean = true;

    @Validate(minValue(1), i18nText("Поле должно быть больше 0"))
    price_first : number|string = '';
    @Validate(minValue(1), i18nText("Поле должно быть больше 0"))
    price_second : number|string = '';

    @Validate(required, i18nText("Введите длительность услуги"))
    service_duration = '';

    image = null;

    category_id : number | null = null;
    category   : IServicesCategoryNomenclature | null = null;

    @Validate(required, i18nText("Является ли запись онлайн"))
    online_appointment : boolean = true;

    getFormData() : ServiceNomenclatureCreateRequestType {
        return {
            active:                     this.active,
            name:                       this.name,
            description:                this.description,
            online_appointment_name:    this.online_appointment_name,
            price_first:                this.price_first,
            price_second:               this.price_second,
            service_duration:           this.service_duration,
            category_id:                this.category_id,
            image:                      this.image,
            online_appointment:         this.online_appointment,
        }
    }

    setFormData(serviceCategory: IServicesCategoryNomenclature): void {
        this.category = serviceCategory;
    }
}
